// Brand-wide constants for iExplore
export const BRAND = {
  name: "iExplore",
  tagline: "Explore Beyond Limits",
  email: "inquiry.iexplore@gmail.com",
  phone: "+91 84595 67554",
  whatsappNumber: "918459567554", // E.164 without +
  // Original full logo (cream bg) — kept for reference
  logoUrl:
    "https://customer-assets.emergentagent.com/job_ladakh-packages/artifacts/micjt9fd_Logo1.png",
  // Locally-hosted transparent variants (background removed)
  logoTransparent: "/iexplore-logo.png", // navy mark on transparent — for light bgs
  logoLight: "/iexplore-logo-light.png", // cream silhouette on transparent — for dark bgs
};

export const buildWaLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Hi iExplore, I'd like to plan a Ladakh trip. Could you share details?"
  );
  return `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
};

export const HIGHLIGHTS = [
  {
    name: "Pangong Lake",
    blurb:
      "A 120-km saltwater dream that shifts colour with the sun — the heart of high-altitude Ladakh.",
    image:
      "https://images.unsplash.com/photo-1681843279178-7f830d2a5d85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    altitude: "14,270 ft",
  },
  {
    name: "Nubra Valley",
    blurb:
      "A green oasis between the Karakoram and the Ladakh range — silk-route memories and Bactrian camels.",
    image:
      "https://images.unsplash.com/photo-1624890240392-da0b1aa01c90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    altitude: "10,000 ft",
  },
  {
    name: "Khardung La",
    blurb:
      "The legend. One of the world's highest motorable roads, gateway to Nubra and beyond.",
    image:
      "https://images.unsplash.com/photo-1718679388215-75b00db812f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    altitude: "18,380 ft",
  },
  {
    name: "Umling La",
    blurb:
      "The highest motorable road on Earth. A pilgrimage for adventurers, an experience for a lifetime.",
    image:
      "https://images.unsplash.com/photo-1744197068961-18194526c236?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    altitude: "19,300 ft",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ananya & Rohit",
    location: "Mumbai",
    trip: "Exotic Ladakh with Umling La",
    quote:
      "Rohan and the iExplore team thought of every detail — the acclimatisation pacing, the camp by Pangong, the surreal drive to Umling La. We've travelled a lot. This was different.",
  },
  {
    name: "The Iyer Family",
    location: "Bengaluru",
    trip: "Monastery Escape",
    quote:
      "Travelling with parents in Ladakh seemed difficult. iExplore made it feel effortless. Honest, transparent, and deeply local — exactly what we needed.",
  },
  {
    name: "Karan Mehta",
    location: "Delhi",
    trip: "Srinagar – Leh – Turtuk",
    quote:
      "The Zoji La drive, the night in Turtuk, the sunrise at Pangong. A trip I'll remember for the rest of my life. Plan with iExplore — they actually know Ladakh.",
  },
];

export const WHY_CHOOSE = [
  {
    title: "Local Expertise",
    body:
      "A decade of on-ground experience in Ladakh. We know the routes, the weather windows, and the hidden corners.",
  },
  {
    title: "Handpicked Stays",
    body:
      "From boutique hotels in Leh to lakeside camps and homestays in Hanle — every property personally vetted.",
  },
  {
    title: "24/7 Support",
    body:
      "Real humans, real numbers, real-time. Before, during and after your trip — we are reachable.",
  },
  {
    title: "Honest Pricing",
    body:
      "No hidden costs, no surge tactics. Transparent itineraries with budget-to-premium flexibility.",
  },
];
